module.exports = __webpack_public_path__ + "img/pay-select-vn.30cc83c2.png";